import {CANONICAL_ORIGIN, PREVIOUS_ORIGIN} from '../core/site';
import {element} from './dom';

/** A domain redirect cannot carry IndexedDB or localStorage. Never delete either. */
export async function siteTransition(): Promise<boolean> {
  if (location.origin !== PREVIOUS_ORIGIN) return false;
  let localWork = true;
  let hasAssets = true; // If storage cannot be inspected, preserve export access.
  try {
    localWork = Object.keys(localStorage).some(key => /^slides2:(draft|import|recovery):/.test(key));
    if ('databases' in indexedDB) {
      const databases = await indexedDB.databases();
      hasAssets = false;
      if (databases.some(db => db.name === 'slides2-assets')) {
        hasAssets = await new Promise<boolean>((resolve, reject) => {
          const request = indexedDB.open('slides2-assets');
          request.onerror = () => reject(request.error);
          request.onsuccess = () => {
            const db = request.result;
            if (!db.objectStoreNames.contains('assets')) { db.close(); resolve(false); return; }
            const count = db.transaction('assets').objectStore('assets').count();
            count.onsuccess = () => { db.close(); resolve(count.result > 0); };
            count.onerror = () => { db.close(); reject(count.error); };
          };
        });
      }
    }
  } catch { hasAssets = true; }
  const target = `${CANONICAL_ORIGIN}${location.pathname}${location.search}${location.hash}`;
  if (!localWork && !hasAssets) {
    location.replace(target);
    return true;
  }
  const notice = element('aside', 'site-transition');
  notice.append(element('span', '', 'Saved work stays on this address. Export source before switching.'));
  const link = element('a', 'button button-quiet', 'Open Slides');
  link.href = target;
  notice.append(link);
  document.body.append(notice);
  return false;
}
